import uuid4 from '../../../node_modules/@buzzfeed/bf-utils/lib/uuid4/index.js';
import storage from '../../../node_modules/@buzzfeed/bf-utils/lib/storage/index.js';
import { GLOBAL_NAMESPACE } from '../../constants.js';

/**
 * Returns `page_session_id` and `previous_page_session_id` from local localStorage. On route
 * changes, a new `page_session_id` is generated while the old value is stored as the
 * `previous_page_session_id`.
 * @return {Object} Containing page session key/value pairs for the common client metadata layer
 */
var pageSessionIds = (url => {
  /**
   * @TODO We can later come up with a strategy to remove the pixiedust reference ("pdv3") from
   * the storage key if theres ever a need.
   */
  const previous_page_session_id_key = 'pdv3-previous_page_session_id';
  const page_session_id_key = 'cet-page_session_id';

  /**
   * If uuid4 returns a falsey value, return a sentinel value representing a uuid.
   * @TODO
   * Verify if `null` could be returned by this method, and if confirmed, fix or move this logic to
   * uuid4 in bf-utils
   */
  const getUuid4 = () => uuid4() || '00000000-0000-0000-0000-000000000000';

  /**
   * Check if another instance of this library has already handled session id's for the current url
   * route and make sure the page_session_id value was successfully stored in localStorage. If so,
   * return the values from localStorage and nothing else. This prevents a race condition when
   * updating session ids.
   */
  // frameElement will return value if it is from within iframe on same domain.  In that case,
  //  use that as the window to synchronize values
  const win = window.frameElement ? window.parent : window;
  let page_session_id = storage.get(page_session_id_key);
  win[GLOBAL_NAMESPACE] = win[GLOBAL_NAMESPACE] || {};
  if (win[GLOBAL_NAMESPACE].current_page_session_url === url && page_session_id) {
    return {
      page_session_id,
      previous_page_session_id: storage.get(previous_page_session_id_key) || ''
    };
  }
  win[GLOBAL_NAMESPACE].current_page_session_url = url;
  page_session_id = getUuid4();
  const previous_page_session_id = storage.get(page_session_id_key) || '';
  storage.set({
    key: page_session_id_key,
    value: page_session_id
  });
  storage.set({
    expires: 1800000,
    // 0.5 hour
    key: previous_page_session_id_key,
    value: previous_page_session_id
  });
  return {
    page_session_id,
    previous_page_session_id
  };
});

export default pageSessionIds;
